import { useSuspenseQuery } from "@tanstack/react-query";
import { orderHistoryClaimApi } from "@/features/my-order/features/order-history/features/claim/api";
import useIdentity from "@/features/ui/hooks/use-identity";
import { companyTypeRequestFormatConverter } from "@/utils/converter";
import useOrderHistoryDetail from "@/features/my-order/features/order-history/hooks/useOrderHistoryDetail";
import { toCamelKeyObject } from "@/utils/case";
import { GetClaimsResponse } from "@/features/my-order/features/order-history/features/claim/types";

const useGetClaimList = () => {
  const identity = useIdentity();
  const { orderSheetSetId } = useOrderHistoryDetail();

  const companyType =
    companyTypeRequestFormatConverter[identity?.company?.type ?? "BUYER"];
  const companyId = identity?.company?.id;

  const canFetch = orderSheetSetId && companyId && companyType;

  const { data } = useSuspenseQuery({
    queryKey: [
      "order-history",
      "claim-list",
      companyType,
      companyId,
      orderSheetSetId,
    ],
    queryFn: () => {
      if (!canFetch) {
        return Promise.reject(new Error("Missing required parameters"));
      }
      return orderHistoryClaimApi.getClaimList(
        companyType,
        companyId,
        orderSheetSetId
      );
    },
    select: (data) => toCamelKeyObject(data) as GetClaimsResponse,
  });

  return { data };
};

export default useGetClaimList;
